import { useEffect, useCallback } from "react";
import { assignFeatureFlags } from "./assignFeatureFlags";
import { client } from "./initFeatureFlags";
export const useConfigChangeSync = (user) => {
    const initializedClient = client;
    const configChangedCallback = useCallback(async () => {
        await assignFeatureFlags(user, false);
    }, [user]);
    useEffect(() => {
        if (!initializedClient) {
            console.error("ERROR: Trying to add listener without having run initFeatureFlags()");
            return;
        }
        initializedClient.on("configChanged", configChangedCallback);
        return () => {
            initializedClient.off("configChanged", configChangedCallback);
        };
    }, [configChangedCallback]);
};
